if (typeof DiscountProgressBar !== "function") {
  class DiscountProgressBar extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold);
      this.currency = this.dataset.cartCurrency;

      this.progressContent = this.querySelector(
        ".progress-text, .progress-bar"
      ).parentElement;
      this.progressText = this.querySelector(".progress-text");
      this.progressBar = this.querySelector(".progress-bar");
      this.thresholdMessage = this.querySelector(".threshold-reached-message");

      this.querySelector(".threshold-amount").textContent = `$${(
        this.threshold / 100
      ).toFixed(0)}`;

      // Initial update
      this.updateProgress();

      // Listen for cart updates
      document.addEventListener("cart-updated", () => {
        this.updateProgress();
      });
      document.addEventListener("add-to-cart", () => {
        this.updateProgress();
      });
    }

    updateProgress() {
      const cartTotalEl = document.querySelector(
        ".cart__total-original[data-cart-total-original]"
      );
      if (!cartTotalEl) return;

      // Remove $ and parse to float, then convert to cents
      const cartTotalText = cartTotalEl.textContent.replace(/[^0-9.]/g, "");
      const cartTotal = Math.round(parseFloat(cartTotalText) * 100) || 0;

      const remaining = this.threshold - cartTotal;
      const width = Math.min((cartTotal / this.threshold) * 100, 100);

      if (remaining > 0) {

        if (this.classList.contains("success")) {
          this.classList.remove("success");
        }
        // Show progress
        this.progressText.style.display = "block";
        this.progressBar.style.display = "block";
        this.thresholdMessage.style.display = "none";
        

        this.querySelector(".current-amount").textContent = `$${(
          cartTotal / 100
        ).toFixed(0)}`;
        this.querySelector(
          ".remaining-text"
        ).textContent = ` - Save 26% on orders $${(
          this.threshold / 100
        ).toFixed(0)}+`;
        this.querySelector(".progress-fill").style.width = `${width}%`;
      } else {
        // Hide progress, show message
        this.progressText.style.display = "none";
        this.progressBar.style.display = "none";
        this.thresholdMessage.style.display = "block";
        if (!this.classList.contains("success")) {
          this.classList.add("success");
        }
      }
    }
  }
  customElements.define("discount-progress-bar", DiscountProgressBar);
}
